<div class="modal fade" tabindex="-1" role="dialog" id="veiculo-estoque-filtro">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 translate class="modal-title">{{'relatorioVeiculos.veiculoEstoque.filtros.definirFiltros'}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container striped-rows">
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'relatorioVeiculos.veiculoEstoque.filtros.grupoEconomico'}}
            </div>
            <div class="col col-8">
              <select class="form-control form-control-sm" type="text" placeholder="Selecione o grupo econômico..."
                [(ngModel)]="GrupoEconomico">
                <option translate value="">{{'relatorioVeiculos.veiculoEstoque.filtros.grupoEconomicoPlaceHolder'}}
                </option>
                <option *ngFor="let item of gruposEconomicos" [value]="item.id"> {{item.descricao}} </option>
              </select>
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'relatorioVeiculos.veiculoEstoque.filtros.chassi'}}
            </div>
            <div class="col col-8">
              <input class="form-control form-control-sm" type="text"
                placeholder="{{'relatorioVeiculos.veiculoEstoque.filtros.chassiPlaceHolder' | translate}}"
                [(ngModel)]="filtros.chassi">
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'relatorioVeiculos.veiculoEstoque.filtros.tipo'}}
            </div>
            <div class="col col-8">
              <select class="form-control form-control-sm" type="text" placeholder="Selecione o Tipo..."
                [(ngModel)]="situacao">
                <option translate value="">{{'relatorioVeiculos.veiculoEstoque.filtros.tipoPlaceHolder'}}</option>
                <option translate value="U">{{'relatorioVeiculos.veiculoEstoque.filtros.usado'}}</option>
                <option translate value="N">{{'relatorioVeiculos.veiculoEstoque.filtros.novo'}}</option>
                <option translate value="P">{{'relatorioVeiculos.veiculoEstoque.filtros.patrimonio'}}</option>
                <option translate value="I">{{'relatorioVeiculos.veiculoEstoque.filtros.imobilizado'}}</option>
                <option translate value="PI">{{'relatorioVeiculos.veiculoEstoque.filtros.patrimonioImobilizado'}}</option>
              </select>
            </div>
          </div>
          <div class="row ptb5" *ngIf="situacao == 'U'">
            <div translate class="col col-4">
              {{'relatorioVeiculos.veiculoEstoque.filtros.marca'}}
            </div>
            <div class="col col-8">
              <select class="form-control form-control-sm" type="text" placeholder="Selecione a Marca..."
                [(ngModel)]="marca">
                <option translate value="">{{'relatorioVeiculos.veiculoEstoque.filtros.marcaPlaceHolder'}}</option>
                <option *ngFor="let item of marcas" [value]="item.descricao"> {{item.descricao}} </option>
              </select>
            </div>
          </div>
          <div class="row ptb5" *ngIf="situacao == 'U'">
            <div translate class="col col-4">
              {{'relatorioVeiculos.veiculoEstoque.filtros.placa'}}
            </div>
            <div class="col col-8">
              <input class="form-control form-control-sm" type="text"
                placeholder="{{'relatorioVeiculos.veiculoEstoque.filtros.placa' | translate}}"
                [(ngModel)]="filtros.placa">
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'relatorioVeiculos.veiculoEstoque.filtros.status'}}
            </div>
            <div class="col col-8">
              <select class="form-control form-control-sm" type="text" placeholder="Selecione o Tipo..."
                [(ngModel)]="filtros.status" [disabled]="situacao=='P'">
                <option translate value="">{{'relatorioVeiculos.veiculoEstoque.filtros.statusPlaceHolder'}}</option>
                <option translate value="N">{{'relatorioVeiculos.veiculoEstoque.filtros.estoque'}}</option>
                <option translate value="S">{{'relatorioVeiculos.veiculoEstoque.filtros.reservado'}}</option>
                <option translate value="B">{{'relatorioVeiculos.veiculoEstoque.filtros.bloqueado'}}</option>
                <option translate value="T">{{'relatorioVeiculos.veiculoEstoque.filtros.transferencia'}}</option>
                <option translate value="TRANSITO">{{'relatorioVeiculos.veiculoEstoque.filtros.transito'}}</option>
                <option translate value="EXPOSICAO">{{'relatorioVeiculos.veiculoEstoque.filtros.exposicao'}}</option>
              </select>
            </div>
          </div>
          <div class="row ptb5" *ngIf="filtros.status != 'T'">
            <div translate class="col col-4">
              {{'relatorioVeiculos.veiculoEstoque.filtros.checkTrans'}}
            </div>
            <div class="col col-4">
              <p-checkbox [(ngModel)]="transferido" [binary]="true"></p-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary" (click)="limparFiltros()">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
        <button type="button" class="btn btn-info" (click)="buscarRegistros()" data-dismiss="modal">OK</button>
      </div>
    </div>
  </div>
</div>